import React from "react";

function IconButton(props) {
    return (
        <div className="tooltip" data-tip={props.text}>
            <button
                className={`${props.className} `}
                disabled={props.disabled}
                type={props.type}
                onClick={props.onClick}
                value={props.value}
            >
                {props.children}
            </button>
        </div>
    );
}

export default IconButton;
